'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _templateObject = _taggedTemplateLiteral(['\n  position: absolute;\n  top: ', 'px;\n  left: ', 'px;\n  width: ', 'px;\n  height: ', 'px;\n  &:hover {\n    .background {\n      background: radial-gradient(gold 0%, rgba(255,215,0,0) 75%);\n    }\n  }\n  cursor: ', ';\n'], ['\n  position: absolute;\n  top: ', 'px;\n  left: ', 'px;\n  width: ', 'px;\n  height: ', 'px;\n  &:hover {\n    .background {\n      background: radial-gradient(gold 0%, rgba(255,215,0,0) 75%);\n    }\n  }\n  cursor: ', ';\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n  position: absolute;\n  left: 0;\n  top: 0;\n  width: 100%;\n  height: 100%;\n'], ['\n  position: absolute;\n  left: 0;\n  top: 0;\n  width: 100%;\n  height: 100%;\n']),
    _templateObject3 = _taggedTemplateLiteral(['\n  position: absolute;\n  left: 0;\n  top: 0;\n  width: 100%;\n  height: 100%;\n  background-image: url(', ');\n  background-size: contain;\n  background-repeat: no-repeat;\n'], ['\n  position: absolute;\n  left: 0;\n  top: 0;\n  width: 100%;\n  height: 100%;\n  background-image: url(', ');\n  background-size: contain;\n  background-repeat: no-repeat;\n']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var Wrapper = _styledComponents2.default.div(_templateObject, function (props) {
  return props.y;
}, function (props) {
  return props.x;
}, function (props) {
  return props.width;
}, function (props) {
  return props.height;
}, function (props) {
  return props.url ? 'pointer' : 'default';
});

var Background = _styledComponents2.default.div(_templateObject2);

var Image = _styledComponents2.default.div(_templateObject3, function (props) {
  return props.image;
});

/** @class Icon
  * A component for rendering an icon that corresponds to a
  * hashtag route within the expo.
  * @prop {URLString} image - the icon image
  * @prop {integer} x - the x position of the icon on the stage
  * @prop {integer} y - the y position of the icon on the stage
  * @prop {URLString} url (optional) - the location to navigate to
  * @prop {integer} width - the width to draw the icon (defaults to the image width)
  * @prop {integer} height - the hieght to draw the icon (defaults to the image hieght)
  */

var Icon = function (_Component) {
  _inherits(Icon, _Component);

  /** @constructor
    * Creates a new icon instance.
    */
  function Icon(props) {
    _classCallCheck(this, Icon);

    var _this = _possibleConstructorReturn(this, (Icon.__proto__ || Object.getPrototypeOf(Icon)).call(this, props));

    _this.handleClick = _this.handleClick.bind(_this);
    return _this;
  }
  /** @method handleClick
    * Loads the icon's corresponding url.
    */


  _createClass(Icon, [{
    key: 'handleClick',
    value: function handleClick() {
      // is there actually a url?
      if (!this.props.url) return;
      // is this an internal or external url?
      if (this.props.url.indexOf('http://') === 0 || this.props.url.indexOf('https://') === 0) {
        // external url
        window.open(this.props.url);
      } else {
        // internal url
        window.location.hash = this.props.url;
      }
    }
    /** @method render
      * Renders the icon.
      */

  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        Wrapper,
        _extends({}, this.props, { onClick: this.handleClick }),
        _react2.default.createElement(Background, { className: 'background' }),
        _react2.default.createElement(Image, this.props)
      );
    }
  }]);

  return Icon;
}(_react.Component);

exports.default = Icon;


Icon.propTypes = {
  image: _propTypes2.default.string.isRequired,
  x: _propTypes2.default.number.isRequired,
  y: _propTypes2.default.number.isRequired,
  width: _propTypes2.default.number.isRequired,
  height: _propTypes2.default.number.isRequired,
  url: _propTypes2.default.string
};


//////////////////
// WEBPACK FOOTER
// ../vexpo-components/build/stage/icon.js
// module id = 1189
// module chunks = 0